import React, { useState,  forwardRef, useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import { AuthorizeContext } from "../../RootContext";
import { Link, useParams } from 'react-router-dom';
import { api_url } from "../../authorize";
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import logo from './../../img/lento_logo.jpg';
import moment from 'moment';
import SchemaFormBuilder from './testUIquery';

import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import MaterialTable from 'material-table';
import Button from '@material-ui/core/Button';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import FlagIcon from '@material-ui/icons/Flag';


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} fontSize="large"/>),
    SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    Flag: forwardRef((props, ref) => <FlagIcon {...props} ref={ref} />),
  };


  // UI ONLY: ActiveList-style presentation. Existing data/API/role/handler logic is unchanged.
  const useStyles = makeStyles((muiTheme) => ({
    page: {
      minHeight: 'calc(100vh - 72px)',
      padding: '28px 20px 44px',
      boxSizing: 'border-box',
      background: '#f3f7f9',
      color: '#173247',
      fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif',
      [muiTheme.breakpoints.down('sm')]: { padding: '20px 16px 32px' },
    },
    shell: {
      width: '100%',
      maxWidth: 'none',
      margin: 0,
    },
    hero: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: 20,
      marginBottom: 20,
      padding: 0,
      border: 'none',
      borderRadius: 0,
      background: 'transparent',
      boxShadow: 'none',
      overflow: 'visible',
      [muiTheme.breakpoints.down('sm')]: {
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: 12,
      },
    },
    heroCopy: { minWidth: 0 },
    eyebrow: {
      margin: 0,
      color: '#0b819d',
      fontSize: 12,
      fontWeight: 800,
      letterSpacing: '0.10em',
      textTransform: 'uppercase',
    },
    heroTitle: {
      margin: '5px 0 0',
      color: '#173247',
      fontSize: 32,
      lineHeight: 1.15,
      fontWeight: 800,
      letterSpacing: '-0.025em',
      [muiTheme.breakpoints.down('xs')]: { fontSize: 27 },
    },
    heroSubtitle: {
      maxWidth: 760,
      margin: '8px 0 0',
      color: '#607888',
      fontSize: 16,
      lineHeight: 1.55,
      fontWeight: 500,
    },
    heroMeta: {
      display: 'flex',
      alignItems: 'center',
      gap: 14,
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      [muiTheme.breakpoints.down('sm')]: { justifyContent: 'flex-start' },
    },
    metaPill: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 7,
      padding: 0,
      border: 'none',
      background: 'transparent',
      color: '#607888',
      fontSize: 14,
      fontWeight: 700,
      whiteSpace: 'nowrap',
      '&::before': {
        content: '\"\"',
        width: 7,
        height: 7,
        borderRadius: '50%',
        background: '#0b819d',
      },
    },
    actionBar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 14,
      marginBottom: 14,
      padding: '14px 18px',
      border: '1px solid #dce7ec',
      borderRadius: 16,
      background: '#ffffff',
      boxShadow: '0 10px 24px rgba(13, 46, 67, 0.06)',
      [muiTheme.breakpoints.down('sm')]: {
        alignItems: 'stretch',
        flexDirection: 'column',
      },
    },
    actionCopy: { minWidth: 0 },
    actionTitle: {
      margin: 0,
      color: '#173247',
      fontSize: 14,
      fontWeight: 800,
      letterSpacing: '0.01em',
    },
    actionHint: {
      margin: '3px 0 0',
      color: '#718897',
      fontSize: 13,
      fontWeight: 500,
      lineHeight: 1.45,
    },
    actionButtons: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      flexWrap: 'wrap',
      [muiTheme.breakpoints.down('xs')]: { '& > button': { width: '100%' } },
    },
    actionButton: {
      minHeight: 38,
      padding: '0 15px',
      borderRadius: 9,
      fontFamily: 'inherit',
      fontSize: 13,
      fontWeight: 700,
      cursor: 'pointer',
      textTransform: 'none',
    },
    secondaryButton: {
      color: '#49647d',
      border: '1px solid #d4e2e8',
      background: '#ffffff',
      boxShadow: 'none',
      '&:hover': { background: '#eef7f9', color: '#0b819d' },
    },
    tableCard: {
      width: '100%',
      overflow: 'hidden',
      marginTop: 0,
      borderRadius: 16,
      border: '1px solid #dce7ec',
      background: '#ffffff',
      boxShadow: '0 16px 36px rgba(13, 46, 67, 0.08)',

      '& > .MuiPaper-root, & .MuiPaper-root': {
        boxShadow: 'none !important',
        borderRadius: '0 !important',
      },
      '& .MuiToolbar-root': {
        minHeight: '68px !important',
        height: 'auto !important',
        padding: '10px 18px !important',
        overflow: 'visible !important',
        borderBottom: '1px solid #e2ebef',
        background: '#ffffff',
      },
      '& .MuiToolbar-root .MuiInputBase-root': {
        color: '#607888',
        fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif',
        fontSize: '15px',
      },
      '& .MuiTableContainer-root': {
        width: '100% !important',
        maxWidth: '100% !important',
        overflowX: 'hidden !important',
      },
      '& .MuiTable-root': {
        width: '100% !important',
        maxWidth: '100% !important',
        minWidth: '0 !important',
        tableLayout: 'fixed !important',
        fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif !important',
      },
      '& .MuiTable-root colgroup': { display: 'none !important' },
      '& .MuiTableCell-root': {
        boxSizing: 'border-box !important',
        minWidth: '0 !important',
        paddingLeft: '9px !important',
        paddingRight: '9px !important',
        overflow: 'hidden !important',
        fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif !important',
        textAlign: 'center !important',
      },
      '& .MuiTableCell-head': {
        paddingTop: '13px !important',
        paddingBottom: '13px !important',
        background: '#f1f6f8 !important',
        color: '#173247 !important',
        borderBottom: '1px solid #dce7ec !important',
        fontSize: '15px !important',
        fontWeight: '800 !important',
        lineHeight: '1.2 !important',
        whiteSpace: 'normal !important',
        wordBreak: 'normal !important',
      },
      '& .MuiTableCell-body': {
        paddingTop: '12px !important',
        paddingBottom: '12px !important',
        borderBottom: '1px solid #edf1f3 !important',
        color: '#244154 !important',
        background: '#ffffff !important',
        backgroundImage: 'none !important',
        fontSize: '16px !important',
        fontWeight: '600 !important',
        lineHeight: '1.3 !important',
        verticalAlign: 'middle',
        whiteSpace: 'normal !important',
        overflowWrap: 'anywhere !important',
      },
      '& .MuiTableBody-root .MuiTableRow-root:hover .MuiTableCell-body': {
        backgroundColor: '#f5fafb !important',
      },
      '& .MuiTableCell-body > div': {
        width: '100% !important',
        minWidth: '0 !important',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        flexWrap: 'wrap',
        textAlign: 'center !important',
      },
      '& .MuiTableCell-body a': {
        color: '#1976d2 !important',
        fontWeight: '700 !important',
        textDecoration: 'none !important',
      },
      '& .MuiTableCell-body a:hover': {
        textDecoration: 'underline !important',
      },
      '& .MuiTableRow-head + .MuiTableRow-root .MuiTableCell-root': {
        background: '#ffffff !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
      },
      '& .MuiInputBase-root': {
        color: '#244154',
        fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif',
        fontSize: 15,
      },
      '& .MuiInput-underline:before': { borderBottomColor: '#cbd9df !important' },
      '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#0b819d !important' },
      '& .MuiTablePagination-root': {
        width: '100% !important',
        maxWidth: '100% !important',
        borderTop: '1px solid #e2ebef',
        background: '#ffffff',
        color: '#607888',
      },
      '& .MuiTablePagination-toolbar': {
        height: 'auto !important',
        minHeight: '52px !important',
        padding: '0 12px !important',
        overflow: 'visible !important',
      },
      '& .MuiIconButton-root': { color: '#49647d', padding: '5px !important' },
      '& .MuiIconButton-root:hover': { background: '#eef7f9', color: '#0b819d' },
    },
    deepTable: {
      '& .MuiTableCell-root:nth-child(1)': { width: '8% !important' },
      '& .MuiTableCell-root:nth-child(2)': { width: '13% !important' },
      '& .MuiTableCell-root:nth-child(3)': { width: '12% !important' },
      '& .MuiTableCell-root:nth-child(4)': { width: '12% !important' },
      '& .MuiTableCell-root:nth-child(5)': { width: '11% !important' },
      '& .MuiTableCell-root:nth-child(6)': { width: '8% !important' },
      '& .MuiTableCell-root:nth-child(7)': { width: '10% !important' },
      '& .MuiTableCell-root:nth-child(8)': { width: '9% !important' },
      '& .MuiTableCell-root:nth-child(9)': { width: '9% !important' },
      '& .MuiTableCell-root:nth-child(10)': { width: '8% !important' },
    },
    tableScroller: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
      overflowX: 'hidden !important',
    },
     previewTitle: {
    margin: '0 0 12px 0',
    fontSize: '16px',
    color: '#fff',
    borderBottom: '1px solid #444',
    paddingBottom: '8px'
  },
    loadingScreen: {
      position: 'fixed',
      width: '100%',
      zIndex: 3,
      height: '100%',
      left: 0,
      top: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#ffffff',
    },
    loadingLogo: {
      display: 'block',
      width: '50%',
      maxWidth: 680,
      height: 'auto',
      objectFit: 'contain',
    },
  }));

  const tableStyles = makeStyles({
    root: {justifyContent: 'space-evenly'},
    spacing: {justifyContent: 'space-evenly'}
  });

  const theme = createTheme({
    palette: {
      primary: { main: '#0b819d' },
      secondary: { main: '#18a39a' },
      background: { default: '#f3f7f9', paper: '#ffffff' },
    },
    typography: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
      h6: { fontWeight: 700 },
    },
  });

const DeepQueryList = () => {
  const classes = useStyles();
  const tableClass = tableStyles();
  const { token, role, user, authBody, setAuthBody, setAuthenticated } = useContext(AuthorizeContext);
  const [data, setData] = useState({})
  const [columnFilters, setColumnFilters ]= useState({});
  let temp = [];
  const [loading, setLoading] = useState(true);
  const [tblData, setTblData] = useState([]);
  const [query, setQuery] = useState([]);
  let { surgeonid } = useParams();
  const [profile, setProfile] = useState(authBody || {role: "visitor"});
  const hasRole = (profile, roles) =>{
    return roles.includes(role);
    console.log(role);
  };
  let deep = [];

  let tableRef = useRef(MaterialTable);

const clearFilter = () => {
        
    localStorage.removeItem('columnFilters');
    localStorage.removeItem('deepSearch');
   window.location.reload();
    }

  let lookup = hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) ?
    {
      1: "New Order",
      2: 'MRI',
      3: 'MRI QC',
      4: 'Planning 1',
      5: 'Planning 2',
      6: 'Surgeon Approval',
      7: 'Template Design',
      8: 'G Code',
      9: 'CNC',
      10: 'Final QC',
      11: 'Shipped',
      12: 'Complete',
      13: 'Aborted'
    } :

    {
      1: hasRole(profile, ['mri_center']) ? 'Ready to Upload MRI' : 'Waiting for MRI',
      2: 'In Progress',
      'MRI':'In Progress',
      3: 'In Progress',
      "MRI_QC": 'In Progress',
      4: 'In Progress',
      'Planning_1':'In Progress',
      5: hasRole(profile, ['distributor', 'surgeon']) ? 'Surgeon Approval Ready' : 'Approval Ready',
      'Planning_2': 'Approval Ready',
      6: 'Surgeon Approved',
      'Surgeon_approval': 'Surgeon Approved',
      7: 'Surgeon Approved',
      'Template_design': 'Manufacturing',
      8: 'Surgeon Approved',
      'G_code': 'Manufacturing',
      9: 'Surgeon Approved',
      'CNC': 'Manufacturing',
      10: 'Surgeon Approved',
      'Final_QC': 'Manufacturing',
      11: 'Shipped',
      'Shipped': 'Shipped'
    }

     const [state, setState] = useState({
    adminColumns: [
      { title: 'Case #', field:'case_id', editable: "never", sort: false, render: rowData => {
          return (
            <div>
              <Link type="text" to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '.7em'
          },
      },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Patient Last Name', field:'Patient.Last_Name', filtering: false,
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Patient First Name', field:'Patient.First_Name', filtering: false,
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: false,
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Expedite', field:'expedite', type:'boolean', filtering: false,
        cellStyle: {
          fontSize: '.7em',
          textAlign: 'center'
        }
      },
      { title: 'Status', field:'case_status', filtering: false,
        lookup: lookup,
        emptyValue: "New Order",
        cellStyle: {
          textAlign: 'center',
          fontSize: '.7em'
        }
      },
      { title: 'Flag', field:'flag_status', filtering: false, editable: 'never', type:'text',
        cellStyle: {
          fontSize: '.7em',
          textAlign: 'center'
        }
      },
       { title: 'Implant', field:'Implant', filtering: false, editable: 'never', type:'text',
        cellStyle: {
          fontSize: '.7em',
          textAlign: 'center'
        }
      },
      // { title: 'Expert Flag', field:'expert_flag', type:'boolean', editable: 'never', filtering: false,
      //   cellStyle: {
      //     fontSize: '.7em',
      //     textAlign: 'center'
      //   }
      // },
    ],

    columns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: true, render:rowData => {
          return (
            <div>
            <Link type="text" to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '.7em'
          }, defaultSort: hasRole(profile, ['distributor']) ? 'asc' : null
      },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '.7em'
        }
      },

      { title: 'Patient Name', field:'Patient.Last_Name', editable: "never", filtering: false, render: rowData => {
        return(
          <div>
            {rowData.Patient.Last_Name}, {rowData.Patient.First_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '.7em'
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },      
      { title: 'DOS', field:'Patient.Date_of_Surgery', editable: "never", filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '.7em'
        }, defaultSort: hasRole(profile, ['surgeon']) ? 'asc' : null,
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Surgery Side', field:'Patient.Side_of_Body', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Status', field:'case_status', filtering: 'false',
        editable: 'never',
        lookup: lookup,
        emptyValue: "New Order",
        cellStyle: {
          background: 'linear-gradient(315deg, #045de9 0%, #09c6f9 74%)',
          backgroundColor: "#045de9",
          color: 'white',
          textAlign: 'center',
          fontSize: '.7em'
        }
      }
    ],
    hosColumns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: false, render:rowData => {
          return (
            <div>
            <Link type="text" to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '.7em'
          }, defaultSort: hasRole(profile, ['distributor']) ? 'asc' : null
      },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Patient Name', field:'Patient.Last_Name', editable: "never", filtering: false, render: rowData => {
        return(
          <div>
            {rowData.Patient.Last_Name}, {rowData.Patient.First_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '.7em'
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'DOS', field:'Patient.Date_of_Surgery', editable: "never", filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '.7em'
        }, defaultSort: hasRole(profile, ['surgeon']) ? 'asc' : null,
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '.7em'
        }
      },
      { title: 'Surgery Side', field:'Patient.Side_of_Body', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '.7em'
        }
      }
    ]
  });

  useEffect(() => {
      deep = JSON.parse(localStorage.getItem('deepSearch'));
      console.log(user)
      if (deep === null){
        deep = []
      } else{
        setState((prevState) => ({
          ...prevState, data: deep
        }));
      }
      setLoading(false)

  }, [setState]);


  const handleClose = () => {
    setState({...state, dialogFlagOpen: false});
  };

  const handleSlotClose = () => {
    setState({...state, dialogMessageOpen: false});

  }
  const handleSubmit = () => {
    axios({
      url: `https://${api_url}/api/case?case_id=${state.rowData.case_id}&update=remove_flag`,
      method: 'put',
      headers: {
        'x-access-token' : token
      }
    }).then(
      res => {
        if(res.data.message){
          alert(res.data.message)
          setState({...state, dialogFlagOpen: false})
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
        setState({...state, dialogFlagOpen: false})
        window.location.reload()
        }

      }
    );
  }

  const handleAssign = () => {
    axios({
      url: `https://${api_url}/api/assign_command`,
      method: 'post',
      headers: {
        'x-access-token' : token
      }
    }).then(
      res => {
        if(res.data.message){
          alert(res.data.message)
          setState({...state, dialogFlagOpen: false})
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
        setState({...state, dialogFlagOpen: false})
        window.location.reload()
        }

      }
    );
  }


    // console.log(state)

  // if(state.data){
  //   console.log(state.data)
  //   if(state.data.notLoggedIn){

  //     setAuthenticated(false);
  //     setAuthBody({role: 'visitor'});
  //     alert("You have been logged out due to inactivity. Please log in again.");
  //     localStorage.removeItem("columnFilters");
  //   }
  // }

  if(loading){
    return(
      <div className={classes.loadingScreen}>
        <img className={classes.loadingLogo} src={logo} alt="logo" />
      </div>
    )
  }

  const recordCount = Array.isArray(state.data) ? state.data.length : 0;
  const roleLabel = String(role || 'user').replace(/_/g, ' ');
  const canClearFilters = hasRole(profile, ['super_admin', 'write_admin', 'read_admin']);
  const pageTitle = hasRole(profile, ['hospital']) ? 'Surgery List' : 'Deep Search';

  return(
    <ThemeProvider theme={theme}>
      <div>
        <main className={classes.page}>
          <div className={classes.shell}>
            <section className={classes.hero}>
              <div className={classes.heroMeta}>
                <span className={classes.metaPill}>User: {user}</span>
              </div>
            </section>
                <SchemaFormBuilder /> 
        <h3 style={useStyles.previewTitle}>Query Results</h3>

            <section className={`${classes.tableCard} ${classes.deepTable}`} aria-label={pageTitle}>
              <div className={classes.tableScroller}>
                <MaterialTable
                  tableRef={tableRef}
                  title={hasRole(profile, ['hospital']) ? "Surgery List" : "Active List"}
                  columns={hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) ? state.adminColumns :
                    hasRole(profile, ['hospital']) ?
                    state.hosColumns
                    :
                    state.columns
                  }
                  data={state.data ? state.data : []}
                  icons={tableIcons}
                  onSearchChange={(e) => console.log("search changed: " + e)}
                  onFilterChange={(e) => {setQuery(e)}}
                  onQueryChange={(e) => console.log("table changed: " + e)}
                  actions={
                    hasRole(profile, ['super_admin', 'write_admin']) ?
                    [{
                      icon: tableIcons.Flag,
                      tooltip: 'Reset Flag',
                      onClick: (event, rowData) => {
                        setState({...state, dialogFlagOpen: true, rowData})
                      }
                    }]
                    :
                    null
                  }
                  editable={
                    hasRole(profile, ['super_admin', 'write_admin', 'distributor']) ?
                    {
                      isEditable: rowData => hasRole(profile, ['distributor']) ? !rowData.po_number : rowData,
                      onRowUpdate: (newData, oldData) =>
                        new Promise((resolve, reject) => {
                          setTimeout(() => {
                            {
                              const data = [...state.data];
                              const index = data.indexOf(oldData);
                              data[index] = newData;

                              console.log(newData)
                              if(oldData.femur_slot != newData.femur_slot ){
                                if((newData.femur_slot == true) || (newData.femur_slot == false)){
                                  axios({
                                    url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=slotSkip&femur=${newData.femur_slot == true ? 1 : 0}`,
                                    method: 'put',
                                    headers: {
                                      'x-access-token' : token
                                    }
                                  }).then(res=> {
                                    if(res.data.message){
                                      setState({...state, dialogMessageOpen: true, oldData, error: res.data.message})
                                    }
                                    else if(res.data.notLoggedIn){
                                      setAuthenticated(false)
                                      setAuthBody({role: 'visitor'})
                                      alert("You have been logged out due to inactivity. Please log in again.")
                                    }
                                    else{
                                      console.log(data[index].femur_slot)
                                      setState({...state, data})
                                      alert("Femur Slot has successfully changed.\nReminder: You can change only one slot at a time.")
                                    }
                                  })
                                }
                              }
                              else if(oldData.tibia_slot != newData.tibia_slot){
                                axios({
                                  url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=slotSkip&tibia=${newData.tibia_slot == true ? 1 : 0}`,
                                  method: 'put',
                                  headers: {
                                    'x-access-token' : token
                                  }
                                }).then(res=> {
                                  if(res.data.message){
                                    setState({...state, dialogMessageOpen: true, oldData, error: res.data.message})
                                  }
                                  else if(res.data.notLoggedIn){
                                    setAuthenticated(false)
                                    setAuthBody({role: 'visitor'})
                                    alert("You have been logged out due to inactivity. Please log in again.")
                                  }
                                  else{
                                    setState({...state, data})
                                    alert("Tibia Slot has successfully changed.\nReminder: You can change only one slot at a time.")
                                  }
                                })
                              }
                              else if (oldData.expedite != newData.expedite){
                                console.log("hi")
                                axios({
                                  url: `https://${api_url}/api/case?case_id=${oldData.case_id}&update=expedite&expedite=0`,
                                  method: 'put',
                                  headers: {
                                    'x-access-token' : token
                                  }
                                }).then(res=> {
                                  if(res.data.message){
                                    setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                                    window.location.reload()
                                  }
                                  else if(res.data.notLoggedIn){
                                    setAuthenticated(false)
                                    setAuthBody({role: 'visitor'})
                                    alert("You have been logged out due to inactivity. Please log in again.")
                                  }
                                  else{
                                    setState({...state, data})
                                    alert(`Case ${oldData.case_id} has been unassigned and expedite status has been removed. To expedite and assign an expert, go to the case details page `)
                                    window.location.reload()
                                  }
                                })
                              }
                              else if (oldData.geo != newData.geo){
                                axios({
                                  url: `https://${api_url}/api/case?case_id=${oldData.case_id}&update=geo&geo=${newData.geo}`,
                                  method: 'put',
                                  headers: {
                                    'x-access-token' : token
                                  },
                                  data: newData
                                }).then(res=> {
                                  if(res.data.message){
                                    setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                                  }
                                  else if(res.data.notLoggedIn){
                                    setAuthenticated(false)
                                    setAuthBody({role: 'visitor'})
                                    alert("You have been logged out due to inactivity. Please log in again.")
                                  }
                                  else{
                                    setState({...state, data})
                                    alert(`Case ${oldData.case_id} geo has been changed.`)
                                    window.location.reload()
                                  }
                                })
                              }
                              else if (oldData.po_number !== newData.po_number){
                                axios({
                                  url: `https://${api_url}/api/case?case_id=${oldData.case_id}&update=new_po`,
                                  method: 'put',
                                  headers: {
                                    'x-access-token' : token
                                  },
                                  data: newData
                                }).then(res=> {
                                  if(res.data.message){
                                    setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                                    window.location.reload()
                                  }
                                  else if(res.data.notLoggedIn){
                                    setAuthenticated(false)
                                    setAuthBody({role: 'visitor'})
                                    alert("You have been logged out due to inactivity. Please log in again.")
                                  }
                                  else{
                                    setState({...state, data})
                                    alert("PO Number has been issued successfully")
                                    window.location.reload()
                                  }
                                })
                              }
                              else if (newData.case_status > oldData.case_status || newData.case_status == 1){
                                reject(new Error(newData))
                                alert("Error: Status will not change. Please choose statuses previous to the current status.")
                              }
                              else if (oldData.case_status == 11 && !oldData.postpone){
                                reject(new Error(newData))
                                alert("Error: Status will not change. Order has already been shipped.")
                              }
                              else if(oldData.case_status == newData.case_status){
                                if(oldData == newData){
                                  reject(new Error(newData))
                                  alert("Error: Status will not change. Status already in progress.")
                                }
                                else{
                                  axios({
                                    url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=edit_patient`,
                                    method: 'put',
                                    headers: {
                                      'x-access-token' : token
                                    },
                                    data: newData
                                  }).then(res=> {
                                    if(res.data.message){
                                      console.log(newData)
                                      setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                                    }
                                    else if(res.data.notLoggedIn){
                                      setAuthenticated(false)
                                      setAuthBody({role: 'visitor'})
                                      alert("You have been logged out due to inactivity. Please log in again.")
                                    }
                                    else{
                                      alert(`Case ${oldData.case_id} patient data has been successfully updated.`)
                                      window.location.reload()
                                    }
                                  })
                                }
                              }
                              else if (oldData.case_status !== newData.case_status){
                                setState({ ...state, data });
                                console.log(newData)
                                console.log(data)
                                console.log(state)
                                axios({
                                  url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=change_case_status&change_status=${newData.case_status}`,
                                  method: 'put',
                                  headers: {
                                    'x-access-token' : token
                                  }
                                }).then(res=> {
                                  if(res.data.message){
                                    setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                                    window.location.reload()
                                  }
                                  else if(res.data.notLoggedIn){
                                    setAuthenticated(false)
                                    setAuthBody({role: 'visitor'})
                                    alert("You have been logged out due to inactivity. Please log in again.")
                                  }
                                  else{
                                    alert(`Case ${oldData.case_id} patient data has been successfully updated.`)
                                    window.location.reload()
                                  }
                                })
                              }
                            }
                            resolve()
                          }, 1000);
                        })
                    }
                    :
                    null
                  }
                  localization={{
                    pagination: {
                      labelDisplayedRows: '{from}-{to} of {count}'
                    },
                    toolbar: {
                      nRowsSelected: '{0} row(s) selected'
                    },
                    header: {
                      actions: 'Edit'
                    },
                    body: {
                      emptyDataSourceMessage: 'No records to display',
                      filterRow: {
                        filterTooltip: 'Filter'
                      },
                      // editTooltip: "Create",
                    }
                  }}
                  options={{
                    actionsColumnIndex: hasRole(profile, ['super_admin', 'write_admin']) ? 9 : 1,
                    sorting: false,
                    search: true,
                    toolbar: true,
                    columnsButton: true,
                    pageSize: 20,
                    filtering: false,
                    showTitle: false,
                    padding: 'dense',
                    tableLayout: 'fixed',
                    emptyRowsWhenPaging: false,
                    headerStyle: {
                      backgroundColor: '#f1f6f8',
                      color: '#173247',
                      fontSize: '15px',
                      fontWeight: 800,
                      whiteSpace: 'normal',
                      lineHeight: 1.2,
                      textAlign: 'center'
                    },
                    rowStyle: {
                      color: '#244154',
                      fontSize: '16px',
                      textAlign: 'center'
                    },
                    filterCellStyle: {
                      backgroundColor: '#ffffff'
                    },
                    searchFieldStyle: {
                      width: 280,
                      maxWidth: '36vw',
                      fontSize: '15px'
                    }
                  }}
                  style={{
                    width: '100%',
                    boxShadow: 'none',
                    fontSize: '16px'
                  }}
                />
              </div>
            </section>
          </div>
        </main>
    <Dialog open={state.dialogFlagOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        <span style={{ fontSize: '2em'}}>WARNING: RESET FLAG</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{fontSize: "1.5em"}}>
        Flag will reset for Case: {state.rowData ? state.rowData.case_id : null}.
        { state.rowData ?
          state.rowData.case_status == 2 ?
          " Are you sure you want to reset the flag or RESCAN? If RESCAN, please click case and click RESCAN button."
          :
          " Are you sure you want to reset the flag?"

          :
          null
        }
        </DialogContentText>
      </DialogContent>
      <DialogActions
        disableSpacing
        classes={{
          root: tableClass.root,
          spacing: tableClass.spacing
        }}
      >
        <button className="btn btn-success" onClick={handleSubmit} variant="contained" style={{fontSize: '2em'}}>
          Yes
        </button>
        <button className="btn btn-danger" onClick={handleClose} style={{fontSize: '2em'}}>
          No
        </button>
      </DialogActions>
    </Dialog>
    <Dialog open={state.dialogMessageOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        <span style={{ fontSize: '2em'}}>WARNING</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{fontSize: "1.5em"}}>
        {state.oldData ? state.oldData.case_id : null} will not change slot. {state.error ? state.error.replace("_", " ") : null}.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSlotClose} color="primary" style={{fontSize: "1em"}}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
      </div>
    </ThemeProvider>
  );
};

export default DeepQueryList;